import bg from "../img/bg.png";
import React from "react";

import css from "../css/background.module.css";

export const Background = () => {
    return (
        <div style={{backgroundImage: `url('${bg}')`}} className={css.background}/>
    )
}
